import { currentPageQuery } from "@/utils/constants";
import { useRouter } from "@/hooks/useCompatRouter";
import { useEffect, useState } from "react";

import {
  hasQueryPrefix,
  queryPrefix,
  removeQueryPrefix,
} from "@/utils/query-prefix";

export { hasQueryPrefix, queryPrefix, removeQueryPrefix };
export const addQueryPrefix = (key: string) => queryPrefix + key;

const maxProductPerRow = 4;

const useProductsFilter = (widgets: Widget[] = []) => {
  const router = useRouter();
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);

  // const perPage = useMemo(
  //   () =>
  //     widgets.filter((w) => w.name === "product-row").length * maxProductPerRow,
  //   [widgets]
  // );

  useEffect(() => {
    const perPage =
      widgets.filter((w) => w.name === "product-row").length * maxProductPerRow;

    setPerPage(perPage);
  }, [widgets]);

  useEffect(() => {
    const currentPage = router.query?.[currentPageQuery] || 1;

    setCurrentPage(+currentPage);
    setActivePage(+currentPage);
  }, [router.query]);

  const handleFilter = (key: string, value: string) => {
    const url = new URLSearchParams();

    url.set(addQueryPrefix(key), value);

    const query = {
      ...router.query,
      ...Object.fromEntries(url),
    };

    // remove empty query
    Object.keys(query).forEach((key) => {
      if (!query[key]) {
        delete query[key];
      }
    });

    router.push(
      {
        pathname: router.pathname,
        query: query,
      },
      undefined,
      { shallow: true }
    );
  };

  const handleFilterByURL = (url: URLSearchParams) => {
    const query = {
      ...router.query,
      ...Object.fromEntries(url),
    };

    // remove empty query
    Object.keys(query).forEach((key) => {
      if (!query[key]) {
        delete query[key];
      }
    });

    router.push(
      {
        pathname: router.pathname,
        query: query,
      },
      undefined,
      { shallow: true }
    );
  };

  return {
    handleFilter,
    handleFilterByURL,
    openFilterModal,
    setOpenFilterModal,

    activePage,
    setActivePage,

    currentPage,
    setCurrentPage,

    perPage,
    setPerPage,

    maxCol: maxProductPerRow,
  };
};

export default useProductsFilter;
